<template>
  <v-card tile flat class="mt-4">
    <v-card-text>
      <v-form autocomplete="off">
        <v-row>
          <v-col cols="12" sm="6" md="3" lg="3" class="py-0">
            <v-select
              clearable
              dense
              :disabled="current_user.lingkup.tingkat != 1"
              outlined
              placeholder="Isikan Propinsi"
              :items="itemProvinsis"
              v-model="filtered.propinsi_id"
              item-value="id"
              item-text="keterangan"
              @change="getKota(filtered.propinsi_id)"
              label="Propinsi"
              data-vv-name="provinsi"
              data-vv-as="Propinsi"
              v-validate="'required'"
              :error-messages="errors.collect('form.provinsi')"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="3" class="py-0">
            <v-select
              clearable
              dense
              :disabled="statusBlockKota"
              outlined
              placeholder="Isikan Kota/Kabupaten"
              :items="itemKotas"
              v-model="filtered.kota_id"
              @change="getKecamatan(filtered.kota_id)"
              item-value="id"
              item-text="keterangan"
              label="Kota/Kabupaten"
              data-vv-name="kota"
              data-vv-as="Kota/Kabupaten"
              v-validate="'required'"
              :error-messages="errors.collect('form.kota')"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="3" class="py-0">
            <v-select
              clearable
              dense
              outlined
              :disabled="statusBlockKecamatan"
              placeholder="Isikan Kecamatan"
              :items="itemKecamatans"
              v-model="filtered.kecamatan_id"
              item-value="id"
              item-text="keterangan"
              @change="getKelurahan(filtered.kecamatan_id)"
              label="Kecamatan"
              data-vv-name="kecamatan"
              data-vv-as="Kecamatan"
              v-validate="'required'"
              :error-messages="errors.collect('form.kecamatan')"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="3" class="py-0">
            <v-select
              clearable
              dense
              outlined
              placeholder="Isikan Kelurahan"
              :items="itemKelurahans"
              v-model="filtered.kelurahan_id"
              item-value="id"
              item-text="keterangan"
              @change="$emit('filter', filtered)"
              label="Kelurahan"
              data-vv-name="keurahan"
              data-vv-as="Kelurahan"
              v-validate="'required'"
              :error-messages="errors.collect('form.keurahan')"
            ></v-select>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: {
    masters: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dialog: true,
      filtered: {
        propinsi_id: null,
        kota_id: null,
        kecamatan_id: null,
        kelurahan_id: null
      },
      itemProvinsis: [],
      itemKotas: [],
      itemKecamatans: [],
      itemKelurahans: [],
      itemKategories: [],
      itemPekerjaans: [],
      idBlockKota: [3, 4],
      idBlockKecamatan: [4],
      statusBlockKota: false,
      statusBlockKecamatan: false
    };
  },
  mounted() {
    this.rend = this.rend + 1;

    this.statusBlockKota = this.idBlockKota.includes(this.current_user.lingkup.tingkat) ? true : false;
    this.statusBlockKecamatan = this.idBlockKecamatan.includes(this.current_user.lingkup.tingkat) ? true : false;

    this.getProvinsi();
  },
  methods: {
    getProvinsi() {
      return this.$store
        .dispatch("warga/getProvinsi", {
          params: {}
        })
        .then(res => {
          this.itemProvinsis = res;
          if (!this.edit && this.current_user.lingkup.tingkat == 3) {
            this.filtered.propinsi_id = this.current_user.lingkup.propinsi_id;
            this.getKota(this.filtered.propinsi_id);
          } else if (!this.edit && this.current_user.lingkup.tingkat == 4) {
            this.filtered.propinsi_id = this.current_user.lingkup.propinsi_id;
            this.getKota(this.filtered.propinsi_id);
          } else if (!this.edit && this.current_user.lingkup.tingkat == 2) {
            this.filtered.propinsi_id = this.current_user.lingkup.id;
            this.getKota(this.filtered.propinsi_id);
          }
        })
        .catch(e => e);
    },
    getKota(id) {
      if (this.filtered.propinsi_id) {
        if (this.current_user.lingkup.tingkat === 1) {
          this.$emit("filter", this.filtered);
        }
        return this.$store
          .dispatch("warga/getKota", {
            id: id,
            params: {}
          })
          .then(res => {
            this.itemKotas = res;
            if (!this.edit && this.current_user.lingkup.tingkat == 3) {
              this.filtered.kota_id = this.current_user.lingkup.id;
              this.getKecamatan(this.filtered.kota_id);
            } else if (!this.edit && this.current_user.lingkup.tingkat == 4) {
              this.filtered.kota_id = this.current_user.lingkup.kota_id;
              this.getKecamatan(this.filtered.kota_id);
            }
          })
          .catch(e => e);
      } else {
        this.filtered.kota_id = null;
        this.filtered.kecamatan_id = null;
        this.filtered.kelurahan_id = null;
        var filteredKota = { propinsi_id: this.filtered.propinsi_id, kota_id: null, kecamatan_id: null, kelurahan_id: null };
        this.$emit("filter", filteredKota);
      }
    },
    getKecamatan(id) {
      if (this.filtered.kota_id) {
        this.$emit("filter", this.filtered);
        return this.$store
          .dispatch("warga/getKecamatan", {
            id: id,
            params: {}
          })
          .then(res => {
            this.itemKecamatans = res;
            if (!this.edit && this.current_user.lingkup.tingkat == 4) {
              this.filtered.kecamatan_id = this.current_user.lingkup.id;
              this.getKelurahan(this.filtered.kecamatan_id);
            }
          })
          .catch(e => e);
      } else {
        this.filtered.kecamatan_id = null;
        this.filtered.kelurahan_id = null;
        var filteredKecamatan = { propinsi_id: this.filtered.propinsi_id, kota_id: this.filtered.kota_id, kecamatan_id: null, kelurahan_id: null };
        this.$emit("filter", filteredKecamatan);
      }
    },
    getKelurahan(id) {
      if (this.filtered.kecamatan_id) {
        this.$emit("filter", this.filtered);
        return this.$store
          .dispatch("warga/getKelurahan", {
            id: id,
            params: {}
          })
          .then(res => {
            this.itemKelurahans = res;
          })
          .catch(e => e);
      } else {
        this.filtered.kecamatan_id = null;
        this.filtered.kelurahan_id = null;
        var filteredKelurahan = { propinsi_id: this.filtered.propinsi_id, kota_id: this.filtered.kota_id, kecamatan_id: this.filtered.kecamatan_id, kelurahan_id: null };
        this.$emit("filter", filteredKelurahan);
      }
    }
  },
  watch: {
    "warga.propinsi_id": function(n) {
      this.getKota(n);
    },
    "warga.kota_id": function(m) {
      this.getKecamatan(m);
    },
    "warga.kecamatan_id": function(o) {
      this.getKelurahan(o);
    },
    "warga.kelurahan_id": function() {
      this.$emit("filter", this.filtered);
    }
  }
};
</script>
